<template>
    <div id="sales-widget" :class="[$mq]">

        <template v-if="hasValidSalesData">
            <div class="sidebar">
                <Timeframes :summary="summary" />
            </div>
            <div class="container">
                <Chart :data="sales" :title="$t('sales.chart.title') + ' ' + formatDate(date)" :height="150" :showLegend="false" />
            </div>
        </template>
        <template v-else>
            <Init :date="date" />
        </template>
    </div>
</template>

<script>
import Chart from '@/components/domain/sales/chart.vue'
import Timeframes from '@/components/domain/sales/timeframes.vue'
import Init from '@/components/domain/sales/init.vue'
import salesMixin from '@/components/domain/sales/salesMixin.js'

// Constants
const REFRESH_INTERVAL_MS = 15 * 60 * 1000 // 15 minutos
const DATE_FORMAT = 'YYYY-MM-DD'

export default {
    name: 'SalesWidget',
    mixins: [salesMixin],
    components: { Chart, Timeframes, Init },
    props: {
        details: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            date: moment().format(DATE_FORMAT),
            refreshIntervalId: null
        }
    },
    methods: {
        async load() {
            try {
                this.date = moment().format(DATE_FORMAT)
                await this.$store.dispatch('sales/loadData', this.date)
            } catch (error) {
                logError('Error loading sales data:', error)
            }
        }
    },
    created() {
        this.load()
        this.refreshIntervalId = setInterval(() => {
            this.load()
        }, REFRESH_INTERVAL_MS)
    },
    beforeDestroy() {
        if (this.refreshIntervalId !== null) {
            clearInterval(this.refreshIntervalId)
            this.refreshIntervalId = null
        }
    }
}
</script>

<style lang="scss" scoped>
#sales-widget {
    padding: 8px;
    width: 100%;
    display: flex;
    flex-direction: row;
    gap: 8px;
    justify-content: center;

    .sidebar {
        width: 30%;
    }

    .container {
        width: 70%;
    }
}

#sales-widget.portrait {
    flex-direction: column;
    gap: 0px;
    .sidebar {
        width: 100%;
    }
    .container {
        width: 100%;
    }
}
</style>
